import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VerifierService {

  constructor(private http: HttpClient) {
  }

  public get(url: string) {
    return this.http.get(url);
  }

  public downloadCertificateFile(url: string): Observable<any> {
    return this.http.get(url, {responseType: 'blob'});
  }

  public downloadCertificate(url: string, formData): Observable<any> {
    return this.http.post(url, formData, {responseType: 'blob'});
  }

  public post(url: string) {
    return this.http.post<any>(url, new FormData());
  }
}
